import React from 'react';
import {debug} from '../../config/config';
import {navigateNext, navigatePrevious} from '../../action/actions';
import {useDispatch} from 'react-redux';
import Api from '../../util/api';

const Debug = () => {
    const dispatch = useDispatch();

    // return null;

    if (!debug) {
        return null;
    }

    return (
        <div style={styles.debug}>
            <div style={{color: '#003333', fontWeight: 'bold', padding: '10px'}}>Debug:</div>
            <div style={{color: '#003333', fontWeight: 'bold', padding: '10px', paddingRight: '5px'}}>App</div>
            <div style={{
                ...styles.button,
                backgroundColor: '#1D7C70',
            }} onClick={() => dispatch(navigatePrevious())}>&lt;&lt;</div>

            <div style={{
                ...styles.button,
                backgroundColor:'#1D7C70',
            }} onClick={() => dispatch(navigateNext())}>&gt;&gt;</div>


            <div style={{color: '#003333', fontWeight: 'bold', padding: '10px', paddingRight: '5px'}}>Device</div>
            <div style={{
                ...styles.button,
                backgroundColor:'#C21D51',
            }} onClick={() => Api.navigateDevicePrevious()}>&lt;&lt;</div>

            <div style={{
                ...styles.button,
                backgroundColor:'#C21D51',
            }} onClick={() => Api.navigateDeviceNext()}>&gt;&gt;</div>

            <div style={{color: '#003333', fontWeight: 'bold', padding: '10px', paddingRight: '5px'}}>Both</div>
            <div style={{
                ...styles.button,
                backgroundColor:'#9E9C0D',
            }} onClick={() => Api.navigateDevicePrevious().then(() => dispatch(navigatePrevious()))}>&lt;&lt;</div>

            <div style={{
                ...styles.button,
                backgroundColor:'#9E9C0D',
            }} onClick={() => Api.navigateDeviceNext().then(() => dispatch(navigateNext()))}>&gt;&gt;</div>
        </div>
    );
}

const styles = {
    debug: {
        backgroundColor: 'rgba(255,255,255,0.5)',
        padding: '10px',
        display: 'flex',
        position: 'absolute',
        left: '0px',
        bottom: '0px',
        right: '0px',
    },
    button: {
        backgroundColor: 'white',
        borderRadius: '4px',
        color: '#ffffff',
        padding: '10px',
        marginLeft: '10px',
    }
};

export default Debug;
